import Axios from "axios";

import {
    getDataWithComp,
    getAlert,
    parseCurrency
} from "./SamuiUtils";

import {
    formatDateTime,
    formatThaiDateUiToDate,
    getCreateDateTime
} from "./DateUtils";

export async function manageItemRemainData(
    arId, // AR_ID ของลูกค้านั้นๆ
    arCode, // AR_Code ของสิ่งนั้นๆ
    arName, // ชื่อลูกค้าคนนั้นๆ
    whId, // WarehouseID (Default ไว้ที่ 0 เสมอ)
    docType, // ประเภท เช่น AI/AO
    payAmt, // ค่าจำนวนของที่ค้าง
    docId, // ไอดีเอกสาร
    docNo, // เลขเอกสาร
    docNoRef, // เลขเอกสารอ้างอิง
    stcRemark // หมายเหตุ
) {
    try {
        // Find ITEM_Remain_Onhand By comp_id, item_id, wh_id
        let findItemOnHand = await getDataWithComp("ITEM_Remain_Onhand", `AND Item_Id = ${arId}`);

        // ถ้าเจอให้ Update ITEM_Remain_Onhand แต่ถ้าไม่เจอให้ Insert ITEM_Remain_Onhand
        if (findItemOnHand.length > 0) {
            // UPDATE ITEM_Remain_Onhand
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/update-item-remain-onhand`, {
                last_qty: payAmt,
                item_on_hand: parseCurrency(await calculateNewQty(docType, findItemOnHand[0].Item_Onhand, payAmt)),
                last_stc_seq: formatDateTime(new Date()),
                last_stc_date: formatThaiDateUiToDate(getCreateDateTime()) + ".000",
                item_id: arId,
                wh_id: whId,
                comp_id: window.localStorage.getItem('company')
            }, {
                headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' }
            });
        } else {
            // INSERT ITEM_Remain_Onhand
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/insert-item-remain-onhand`, {
                item_id: arId,
                item_code: arCode,
                item_name: arName,
                item_barcode: null,
                last_qty: payAmt,
                item_on_hand: payAmt > 0 ? -Math.abs(payAmt) : payAmt,
                wh_id: whId,
                zone_id: parseInt("1", 10),
                lt_id: parseInt("1", 10),
                last_stc_seq: formatDateTime(new Date()),
                last_stc_date: formatThaiDateUiToDate(getCreateDateTime()),
                comp_id: window.localStorage.getItem('company'),
                item_last_onhand: null
            }, {
                headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' }
            });
        }

        // ทำการ Insert ITEM_Remain_STC ทุกกรณี
        // Find TOP(1) ITEM_Remain_STC By item_id, wh_id,comp_id ORDER BY STC_SEQ DESC; 
        // => ต้องการ STC_Balance เพื่อมาบวกกับจำนวนรับแล้ว INSERT ใหม่
        let findItemStc = await getDataWithComp("ITEM_Remain_STC", `AND Item_Id = ${arId} AND WH_Id = ${whId} ORDER BY STC_SEQ DESC`);

        // ถ้าเจอให้ Insert ITEM_Remain_STC เอาค่าเดิมมากบวก แต่ถ้าไม่เจอให้ Insert ITEM_Remain_STC เอา 0 + ค่าใหม่
        if (findItemStc.length > 0) {
            // Insert ITEM_Remain_STC เอาค่าเดิมมากบวก
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/insert-item-remain-stc`, {
                item_id: arId,
                item_code: arCode,
                item_name: arName,
                doc_type: docType,
                ref_balance: parseInt("0", 10),
                stc_qty: payAmt,
                stc_balance: parseCurrency(await calculateNewQty(docType, findItemStc[0].STC_Balance, payAmt)),
                stc_date: formatThaiDateUiToDate(getCreateDateTime()),
                stc_by: window.localStorage.getItem('emp_id'),
                comp_id: window.localStorage.getItem('company'),
                doc_id: docId,
                doc_no: docNo,
                doc_noref: docNoRef,
                stc_remark: stcRemark,
                stc_seq: formatDateTime(new Date()),
                wh_id: whId,
                zone_id: parseInt("1", 10),
                lt_id: parseInt("1", 10)
            }, {
                headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' }
            });
        } else {
            // Insert WH_ARPAYMENT_STC เอา 0 + ค่าใหม่
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/insert-item-remain-stc`, {
                item_id: arId,
                item_code: arCode,
                item_name: arName,
                doc_type: docType,
                ref_balance: parseInt("0", 10),
                stc_qty: payAmt,
                stc_balance: parseCurrency(await calculateNewQty(docType, parseInt("0", 10), payAmt)),
                stc_date: formatThaiDateUiToDate(getCreateDateTime()),
                stc_by: window.localStorage.getItem('emp_id'),
                comp_id: window.localStorage.getItem('company'),
                doc_id: docId,
                doc_no: docNo,
                doc_noref: docNoRef,
                stc_remark: stcRemark,
                stc_seq: formatDateTime(new Date()),
                wh_id: whId,
                zone_id: parseInt("1", 10),
                lt_id: parseInt("1", 10)
            }, {
                headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' }
            });
        }
    } catch (error) {
        getAlert("FAILED", "พบข้อผิดพลาด")
        return null;
    }
};

// Method แยกสำหรับคำนวณค่าเงินใหม่
export async function calculateNewQty(docType, currentQty, payAmt) {
    let newQty;

    switch (docType) {
        case 'IN':
        case 'AI':
        case 'TI':
        case 'CC':
            newQty = parseCurrency(currentQty) + parseCurrency(payAmt);
            break;
        case 'OUT':
        case 'AO':
        case 'TO':
            let newPayAmt = payAmt > 0 ? -Math.abs(payAmt) : payAmt
            newQty = (parseCurrency(currentQty)) + (parseCurrency(newPayAmt));
            break;
        default:
            throw new Error(`Unsupported docType: ${docType}`);
    }

    return newQty;
};
